const URL = 'reference-points'

const referencePointsApi = ({ apiClient }) => ({
  /**
   *
   * @param params
   * @returns {*}
   */
  list(params) {
    return apiClient.get(URL, {}, params)
  },

  /**
   *
   * @param {number} id
   * @returns Promise<any>
   */
  show(id) {
    return apiClient.get(`${URL}/${id}`, {}, {})
  },

  /**
   *
   * @param payload
   * @returns {*}
   */
  store(payload) {
    return apiClient.axios().post(URL, payload)
  },

  /**
   *
   * @param id
   * @param payload
   */
  update(id, payload) {
    return apiClient.axios().put(`${URL}/${id}`, payload)
  },

  /**
   *
   * @param id
   * @returns {*}
   */
  destroy(id) {
    return apiClient.delete(`${URL}/${id}`)
  },
})

export default referencePointsApi
